import { Field } from 'formik'
import React from 'react'
import { Button } from 'components/Button'
import { Image, IMAGE_LAYOUT } from 'components/Image'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { ASPECT_RATIO } from 'components/UploadImage/constants'
import { COLOR_INTENT, SPACE } from 'Theme'
import { useChangeVideoThumbnailMutation } from 'types/graphql-generated'
import { UploadAttachment } from '../UploadAttachment'

interface VideoAttachmentFieldProps {
  widgetIndex: number
  validationPrefix: string
}

export const VideoThumbnailField = ({
  validationPrefix,
  widgetIndex,
}: VideoAttachmentFieldProps) => {
  const [executeChangeVideoThumbnail] = useChangeVideoThumbnailMutation()
  return (
    <Flex width="100%" flexShrink={0}>
      <Field name={`${validationPrefix}.thumbnailAttachment`}>
        {({ field, meta, form }) => {
          let content = (
            <UploadAttachment
              aspectRatio={ASPECT_RATIO.VIDEO_THUMBNAIL}
              onSelect={async (thumbnailAttachment) => {
                form.setFieldValue(
                  `${validationPrefix}.thumbnailAttachment`,
                  thumbnailAttachment
                )
                const videoId =
                  form.values.widgets[widgetIndex]?.content?.videoAttachment?.id
                if (videoId && thumbnailAttachment) {
                  await executeChangeVideoThumbnail({
                    variables: {
                      input: {
                        videoId,
                        thumbnailAttachmentId: thumbnailAttachment.id,
                      },
                    },
                  })
                }
              }}
            />
          )
          if (field?.value?.url) {
            content = (
              <Flex flexDirection="column">
                <Image
                  layout={IMAGE_LAYOUT.RESPONSIVE}
                  aspectRatio={ASPECT_RATIO.VIDEO_THUMBNAIL}
                  alt="Video thumbnail"
                  src={field.value.url}
                />
                <Button
                  mt={SPACE.PX_15}
                  onClick={() => {
                    form.setFieldValue(
                      `${validationPrefix}.thumbnailAttachment`,
                      {}
                    )
                  }}
                >
                  Change image
                </Button>
              </Flex>
            )
          }
          return (
            <Flex flexDirection="column" width="100%">
              <Text mb={meta.error === undefined ? SPACE.PX_20 : 0}>
                Thumbnail*
              </Text>
              {meta.error && (
                <Text
                  color={COLOR_INTENT.WIDGETS.VIDEO_SECTION.HINT_ERROR_TEXT}
                >
                  {meta.error.id}
                </Text>
              )}
              {content}
            </Flex>
          )
        }}
      </Field>
    </Flex>
  )
}
